import LegalPageLayout from './LegalPageLayout'
import { LEGAL_DOCS } from '../../constants/legalContent'

export default function UserAgreementPage() {
  const doc = LEGAL_DOCS.userAgreement
  return (
    <LegalPageLayout
      pageTitle={doc.pageTitle}
      effectiveDate={doc.effectiveDate}
      sections={doc.sections}
    />
  )
}

